import moment from 'moment';

window.moment = moment;
window.accurateInterval = function(time, fn) {
  var cancel, nextAt, timeout, wrapper, _ref;
  nextAt = new Date().getTime() + time;
  timeout = null;
  if (typeof time === 'function') _ref = [time, fn], fn = _ref[0], time = _ref[1];
  wrapper = function() {
    nextAt += time;
    timeout = setTimeout(wrapper, nextAt - new Date().getTime());
    return fn();
  };
  cancel = function() {
    return clearTimeout(timeout);
  };
  timeout = setTimeout(wrapper, nextAt - new Date().getTime());
  return {
    cancel: cancel,
  };
};

export default {
  init() {
    var utils = {
      getTimeFormatted: function(num) {
        return (num < 10 ? '0' : '') + num;
      },
      getElapsedtime: function(current) {
        var hours = Math.floor(current / 3600);
        current = current % 3600;
  
        var minutes = Math.floor(current / 60);
        current = current % 60;
    
        var seconds = Math.floor(current);
    
        // Pad the minutes and seconds with leading zeros, if required
        minutes = this.getTimeFormatted(minutes);
        seconds = this.getTimeFormatted(seconds);
    
        // Compose the string for display
        var currentTimeString = minutes + ':' + seconds;

        var maxTime = Number(jQuery('.timer-wrapper').attr('data-duration'));
        if (hours > 0 || minutes >= maxTime) {
          helpers.stopExam();
        }
    
        return currentTimeString;
      },
      getCookie: function(cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return '';
      },
      isViewVisible: function(el) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;

        var adminBarHeight = jQuery('#wpadminbar').outerHeight();
        var navBarHeight = jQuery('#header').outerHeight();
    
        return elemTop < window.innerHeight && elemBottom >= (adminBarHeight + navBarHeight);
      },
      getUrlParam: function(name) {
        var url = location.href;

        var regex = new RegExp('[?&]' + name + '=([^&#/]*)/?');
        var results = regex.exec(url);
        return results == null ? null : results[1];
      },
    };

    var helpers = {
      interval: null,
      adjustViewSize: function() {
        var adminBarHeight = jQuery('#wpadminbar').outerHeight();
        var navBarHeight = jQuery('#header').outerHeight();
        var screenHeight = jQuery(window).height();
  
        jQuery('.empty-message-wrapper, .first-step-wrapper').height(screenHeight - navBarHeight - adminBarHeight);
      },
      adjustRightBar: function() {
        if (jQuery(window).width() >= 768) {
          if (jQuery('.second-step-wrapper').is(':visible') &&
              !utils.isViewVisible(jQuery('.title-wrapper').get(0))) {
            jQuery('.right-wrapper').addClass('fixed');
          } else {
            jQuery('.right-wrapper').removeClass('fixed');
          }
        } else {
          jQuery('.right-wrapper').removeClass('fixed');
        }
      },
      initExamWithCookie: function(language) {
        if (!language) {
          navigator.goToStepOne();
        } else {
          navigator.goToStepTwo();
        }
      },
      saveLanguageAndReload: function() {
        document.cookie = 'exam_language=' + jQuery('#language').val();

        location.reload();
      },
      startTimer: function() {
        var maxTime = Number(jQuery('.timer-wrapper').attr('data-duration'));
        var last = jQuery('.timer-wrapper').attr('data-start');

        // Obtenemos el timestamp actual y el de inicio
        var currentSeconds = moment().utc().valueOf() / 1000;
        var startSeconds = Number(last) / 1000;

        // Calculamos los segundos que han pasado
        var elapsedSeconds = last ? Math.min(currentSeconds - startSeconds, maxTime * 60 - 1) : 0;

        // Cada segundo incrementamos el contador
        this.interval = window.accurateInterval(1000, function() {
          elapsedSeconds = elapsedSeconds + 1;
          jQuery('.timer').text(utils.getElapsedtime(elapsedSeconds));
        });
      },
      stopTimer: function() {
        this.interval.cancel();
      },
      stopExam: function() { // En caso de que te pases del tiempo
        var end = moment().utc().format('YYYY-MM-DD HH:mm:ss');
        helpers.stopTimer();
        jQuery('.timer-wrapper').addClass('error');
        window.Swal.fire({
          type: 'error',
          title: translator.translate('oops'),
          text: translator.translate('time-up'),
        });
        api.completeExam(null, end);
      },
    };

    var navigator = {
      goToStepOne: function() {
        jQuery('.first-step-wrapper').show();
        jQuery('.second-step-wrapper').hide();
      },
      goToStepTwo: function() {
        jQuery('.first-step-wrapper').hide();
        jQuery('.second-step-wrapper').show();

        helpers.startTimer();
      },
    };

    var api = {
      showLoading: function() {
        window.Swal.fire({
          title: translator.translate('loading'),
          allowOutsideClick: false,
          allowEscapeKey: false,
          onBeforeOpen: () => {
            window.Swal.showLoading();
          },
        })
      },
      hideLoading: function() {
        window.Swal.close();
      },
      finishExam: function() {
        jQuery('#finish').blur();
        var end = moment().utc().format('YYYY-MM-DD HH:mm:ss');
        var questions = jQuery('.questions-wrapper .question');
        var answered = [];
    
        jQuery(questions).each(function(index, item) {
          var question = jQuery(item);
          question.removeClass('incorrect');
    
          var questionId = question.attr('data-id');
          var questionNumber = question.attr('data-number');
          var answer = question.find('input:checked');
    
          if (answer.get(0)) {
            var answerId = answer.parent('.answer').attr('data-id');
            answered.push({
              id: questionId,
              answer: answerId,
              number: questionNumber,
            });
          } else {
            question.addClass('incorrect');
          }
        });
    
        if (questions.length == answered.length) {
          api.showLoading();
          api.completeExam(answered, end);
        } else {
          window.Swal.fire({
            type: 'error',
            title: translator.translate('oops'),
            text: translator.translate('must-check-all-answers'),
          });
        }
      },
      completeExam: function(data, end) {
        var start = Number(jQuery('.timer-wrapper').attr('data-start'));
        start = moment(start).utc().format('YYYY-MM-DD HH:mm:ss');

        var body = {
          language: utils.getCookie('exam_language'),
          start: start,
          end: end,
          questions: data,
          timeUp: data == null,
          token: utils.getUrlParam('token'),
          type: jQuery('.step-wrapper').attr('data-type'),
        };
        helpers.stopTimer(); //Paramos el tiempo
        jQuery.ajax({
          contentType: 'application/json',
          data: JSON.stringify(body),
          dataType: 'json',
          processData: false,
          type: 'POST',
          url: '/wp-json/exam/complete',
          success: function(response) {
            try {
              if (response.failedQuestions) {
                response.failedQuestions.forEach(q => {
                  var question = jQuery('.question[data-id=' + q.id + ']')
                  question.addClass('incorrect');
                  question.find('input:checked').parent('.answer').addClass('incorrect');
                  question.find('.answer[data-id=' + q.answer + ']').addClass('correct');
                });
              }
              // Si tenemos las fechas del próximo intento
              if (response.start || response.end) {
                var html = jQuery('.fail-wrapper').html();
                html = html.replace('{$Desde2}', response.start);
                html = html.replace('{$Hasta2}', response.end);
  
                jQuery('.fail-wrapper').html(html);
              }
              // Mostramos el resultado del examen
              jQuery(response.status == 0 ? '.fail-wrapper' : '.result-wrapper').show();
              if (data) {
                // Quitamos el loading
                api.hideLoading();
  
                // Mostramos el mensaje
                window.Swal.fire({
                  type: response.status == 1 ? 'success' : 'error',
                  title: translator.translate(response.status == 1 ? 'congratulations' : 'we-are-sorry'),
                  text: translator.translate(response.status == 1 ? 'pass' : 'fail'),
                  onClose: function() {
                    document.cookie = 'exam_language='; // Quitamos la cookie
                  },
                });
              }
              // Actualizamos la vista
              jQuery('.question input').prop('disabled', true);
              if (response.failedQuestions)
                jQuery('.question:not(.incorrect)').find('input:checked').parent('.answer').addClass('correct');
              jQuery('#finish').remove(); // Eliminamos el botón
              jQuery(window).scrollTop(0); // Subimos la vista arriba del todo
            } catch (error) {
              api.hideLoading();
              window.Swal.fire({
                type: 'error',
                title: translator.translate('error'),
                text: translator.translate('error-message'),
              });
              console.error(error);
            }
          },
          error: function() {
            api.hideLoading();
            window.Swal.fire({
              type: 'error',
              title: translator.translate('error'),
              text: translator.translate('error-message'),
            });
          },
        });
      },
    };

    var translator = {
      translations: {
        'es': {
          'title': 'Examen de certificación LPF',
          'information': 'Información',
          'name': 'Nombre',
          'surname': 'Apellidos',
          'level': 'Nivel',
          'social': 'Síguenos en nuestras redes sociales',
          'time': 'Tiempo',
          'finish': 'Terminar',
          'time-up': 'El tiempo se ha acabado.',
          'loading': 'Cargando...',
          'must-check-all-answers': 'Debes contestar a todas las preguntas para terminar el examen',
          'congratulations': '¡Enhorabuena!',
          'we-are-sorry': 'Lo sentimos',
          'pass': 'Has aprobado el examen',
          'fail': 'Has suspendido el examen',
          'error': 'Error',
          'error-message': 'Ha ocurrido un error inesperado al finalizar el examen. Por favor, inténtelo de nuevo.',
          'oops': 'Ups...',
        },
        'en': {
          'title': 'LPF certification exam',
          'information': 'Information',
          'name': 'Name',
          'surname': 'Surname',
          'level': 'Level',
          'social': 'Follow us on our social networks',
          'time': 'Time',
          'finish': 'Finish',
          'time-up': 'The time is up',
          'loading': 'Loading...',
          'must-check-all-answers': 'You must answer all the questions in order to finish the exam',
          'congratulations': 'Congratulations!',
          'we-are-sorry': 'We are sorry',
          'pass': 'You have passed the exam',
          'fail': 'You have not passed the exam',
          'error': 'Error',
          'error-message': 'An unexpected error has occurred while finishing the exam. Please, try again',
          'oops': 'Oops...',
        },'pt': {
          'title': 'Exame de certificação LPF',
          'information': 'Informação',
          'name': 'Nome',
          'surname': 'Sobrenome',
          'level': 'Nível',
          'social': 'Siga-nos nas nossas redes sociais',
          'time': 'Tempo',
          'finish': 'Concluir',
          'time-up': 'O tempo acabou',
          'loading': 'Carga...',
          'must-check-all-answers': 'Você deve responder a todas as perguntas para concluir o exame',
          'congratulations': 'Parabéns!',
          'we-are-sorry': 'Sentimos muito',
          'pass': 'Você passou no exame',
          'fail': 'Você falhou no exame.',
          'error': 'Erro',
          'error-message': 'Ocorreu um erro inesperado no final do exame. Por favor tente novamente',
          'oops': 'oops...',
        },
      },
      translate: function(key) {
        var language = utils.getCookie('exam_language');
        if (!language) language = 'es';
        return this.translations[language][key];
      },
    };

    // Eventos
    jQuery(window).on('resize', helpers.adjustViewSize);
    jQuery('#start').on('click', helpers.saveLanguageAndReload);
    jQuery('#finish').on('click', api.finishExam);

    jQuery(window).on('scroll', helpers.adjustRightBar);

    // Traducciones
    jQuery('[translate]').each(function(index, item) {
      jQuery(item).append(translator.translate(jQuery(item).attr('translate')));
    });

    // Init
    helpers.adjustViewSize();
    if(jQuery('.step-wrapper').is(':visible')) {
      helpers.initExamWithCookie(utils.getCookie('exam_language'));
    }
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/quiz.js